module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ctaHeader":"Compare, switch, and save on your household bills","header":"Latest {name} guides"}}')
  delete Component.options._Ctor
}
